import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profi-update',
  templateUrl: './profi-update.component.html',
  styleUrls: ['./profi-update.component.css']
})
export class ProfiUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
